export const INVALIDATE_PERMISSIONS_SCOPE_CACHE_KEY = "permissions-invalidate-user-scope-cache";
